import { Injectable, NgZone } from "@angular/core";
import { Router, Event, NavigationEnd } from "@angular/router";
import { Activity } from "../model/activity";

declare var cordova: any;

@Injectable()
export class NavigationService {
    private currentRoute: string | null = null;
    public readonly activity: Activity = new Activity();

    constructor (
        private ngZone: NgZone,
        private router: Router,
    ) {
        this.interceptAndroidBackButton();
        this.router.events.pipe().subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentRoute = event.url;
            }
        });
    }

    isCurrentRouteHome(): boolean {
        return this.currentRoute === null
            || this.currentRoute === '/';
    }

    navigateBack(): void {
        if (this.activity && this.activity.onBack) {
            this.activity.onBack(() => this.executeNavigationBack());
        } else {
            this.executeNavigationBack();
        }
    }

    closeApplication(): void {
        cordova?.plugins?.exit();
    }

    private executeNavigationBack(steps?: number): void {
        if (this.isCurrentRouteHome()) {
            this.closeApplication();
        } else {
            window.history.go((steps ?? 1) * (-1));
        }
    }

    private interceptAndroidBackButton(): void {
        document.addEventListener("backbutton", e => {
            e.preventDefault();
            e.stopPropagation();
            this.ngZone.run(() => {
                // Evil Magick (restore focus or else Angular Material dialogs stop working)
                document.getElementById('the_app_back_button')?.focus();
                setTimeout(() => {
                    this.navigateBack();
                }, 1);
            });
        });
    }
}
